<template>
  <div class="supplier-selection">
    <div class="broadband-suppliers">
      <div class="option-wrap" :class="{ answered: answered }">
        <div
          v-for="supplier of suppliers"
          :key="supplier.value"
          class="supplier-option"
          :class="{ selected: isSelected(supplier), [supplier.value]: true }"
          @click="selectSupplier(supplier)"
        >
          <img
            v-if="supplier.img"
            :src="
              isSelected(supplier)
                ? selectedImage(supplier)
                : supplier.img
            "
            :alt="`${supplier.name} logo`"
          >
          <span v-else>{{ supplier.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import isEqual from 'lodash/isEqual'

export default {
  name: 'SupplierSelection',

  props: {
    value: {
      // Answer
      type: Object,
      required: true
    },
    useWhiteSelectedImages: {
      type: Boolean,
      default: false
    },
    checkboxImage: {
      type: String,
      default: 'tick.svg'
    }
  },

  data () {
    return {
      suppliers: [
        {
          name: 'BT Business',
          value: 'BT',
          img: require('@/assets/logos/suppliers/bt/colour.svg'),
          whiteImg: require('@/assets/logos/suppliers/bt/white.svg')
        },
        {
          name: 'Virgin Media',
          value: 'Virgin',
          img: require('@/assets/logos/suppliers/virgin/colour.svg'),
          whiteImg: require('@/assets/logos/suppliers/virgin/white.svg')
        },
        {
          name: 'Sky',
          value: 'Sky',
          img: require('@/assets/logos/suppliers/sky/colour.svg'),
          whiteImg: require('@/assets/logos/suppliers/sky/white.svg')
        },
        {
          name: 'XLN',
          value: 'XLN',
          img: require('@/assets/logos/suppliers/xln/colour.svg'),
          whiteImg: require('@/assets/logos/suppliers/xln/white.svg')
        },
        {
          name: 'Daisy',
          value: 'Daisy',
          img: require('@/assets/logos/suppliers/daisy/colour.svg'),
          whiteImg: require('@/assets/logos/suppliers/daisy/white.svg')
        },
        {
          name: 'Plusnet',
          value: 'Plusnet',
          img: require('@/assets/logos/suppliers/plusnet/colour.svg'),
          whiteImg: require('@/assets/logos/suppliers/plusnet/white.svg')
        },
        {
          name: 'Other provider',
          value: 'Other'
        },
        {
          name: 'No broadband',
          value: 'None'
        }
      ]
    }
  },

  computed: {
    answered () {
      return this.value && this.value.result
    }
  },

  methods: {
    isValid (result) {
      return !!result
    },
    isSelected (supplier) {
      if (this.value && this.value.result) {
        return isEqual(this.value.result, supplier)
      }
    },
    selectSupplier (supplier) {
      this.$emit('input', { result: supplier, valid: this.isValid(supplier) })
    },
    selectedImage (supplier) {
      if (supplier.selectedImage) return supplier.selectedImage
      else if (this.useWhiteSelectedImages) return supplier.whiteImg
      return supplier.img
    }
  }
}
</script>

<style scoped lang="scss">
.supplier-selection {
  .service-header {
    font-weight: bold;
    margin-bottom: $spacing-12;
    font-size: 18px;
  }
}

.option-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  justify-items: center;

  .supplier-option {
    width: calc(25% - 20px);
    margin-bottom: $spacing-28;
    height: 69px;
    border-radius: 8px;
    box-shadow: $supplier-shadow;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    font-size: 18px;
    font-weight: bold;
    padding: $spacing-16;
    background-color: $white;
    cursor: pointer;
    transition: 0.25s all;
    color: $supplier-text;
    background-image: url(~@/assets/icons/radio-icon-inactive.svg);
    background-repeat: no-repeat;
    background-position: left center;
    background-position-x: 16px;
    position: relative;
    top: 0;

    @media (max-width: $screen-md) {
        width: calc(50% - #{$spacing-8});
        margin-bottom: $spacing-16;
        padding: $spacing-12 $spacing-20;
        height: 60px;
        font-size: 14.4px;
        line-height: 19px;
    }

    @media (max-width: $screen-xs) {
      background-position-x: 10px;
    }

    img {
      height: 100%;
    }

    img, span {
      @media (max-width: $screen-md) {
        padding-left: 25px;
      }
      @media (max-width: $screen-xs) {
        padding-left: 30px;
      }
    }

    &:hover {
      box-shadow: 0 2px 11px 0 rgba(30,45,114,0.1);;
      background-image: url(~@/assets/icons/radio-icon-checked-navy.svg);
      top: -4px;
    }

    &.selected {
      box-shadow: $supplier-shadow-selected;
      background-color: $supplier-selected-bg;
      color: $supplier-selected-text;
      background-image: url(~@/assets/icons/radio-icon-checked-navy.svg);
      top: 0;
    }
  }
}
</style>
